const ErrorSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="160"
    height="160"
    fill="none"
    viewBox="0 0 160 160"
  >
    <path
      fill="url(#paint0_linear_1_10286)"
      fillOpacity="0.8"
      d="M157.129 74.8c-3.867 11.165-14.149 10.543-28.935 28.79a98 98 0 0 0-2.654 3.425c-6.926 9.365-9.294 16.091-11.706 21.693-.161.376-.326.748-.487 1.114-.747 1.66-1.52 3.225-2.458 4.74-9.008 14.55-28.589 17.193-29.522 17.304q-1.317.164-2.673.23-.414.031-.828.04c-11.375.427-24.215-3.551-31.689-12.484-2.969-3.546-3.917-6.48-5.076-9.133a24 24 0 0 0-.617-1.319c-.958-1.916-2.242-3.712-4.775-5.543-7.488-5.401-11.992-1.033-21.522-6.69-1.66-.984-8.32-5.147-11.49-12.028-.141-.306-.276-.607-.397-.923a18 18 0 0 1-1.204-4.79c-.15-1.434-.24-3.967.728-7.313 3.726-12.845 15.89-12.785 25.45-24.677 11.274-14.029 6.91-29.748 20.062-39.263a33 33 0 0 1 5.236-3.054c4.364-1.991 8.677-2.704 12.43-2.824.345-.015.681-.02 1.017-.02 3.938-.015 7.173.587 9.059.963 16.752 3.3 16.737 13.236 33.911 19.325 13.266 4.7 31.107 5.101 40.832 9.766.221.11.442.216.652.326 1.485.772 2.754 1.655 3.762 2.683.903.923 1.58 1.916 1.58 1.916 1.354 1.981 2.071 4.183 2.397 6.335.056.351.101.702.126 1.043.511 5.177-1.043 9.866-1.219 10.363z"
    ></path>
    <path
      fill="#fff"
      d="M86.162 78.85c-.682.397-1.37.798-2.056 1.19-5.588 3.2-11.516 5.883-17.5 8.26-5.999 2.383-12.108 4.454-18.292 6.295-6.215 1.85-12.49 3.466-18.81 4.925-6.334 1.465-12.709 2.769-19.094 3.988-2.573.486-5.14.968-7.714 1.424-.14-.306-.276-.607-.396-.923 3.426-.642 6.851-1.269 10.272-1.941 6.35-1.249 12.685-2.583 18.99-4.078 6.269-1.484 12.508-3.144 18.673-5.04a228 228 0 0 0 18.136-6.43 189 189 0 0 0 17.54-8.096c.286-.145.527.271.25.427M150.478 52.461c-3.997 2.292-7.649 5.041-10.919 8.296-.11.105-.216.206-.321.316q-.272.27-.537.557c-3.345 3.47-6.279 7.313-8.948 11.315-5.747 8.637-10.186 18.042-15.623 26.86-5.487 8.902-12.244 17.213-21.262 22.73-9.214 5.643-19.907 8.532-30.64 9.129-7.028.391-14.135-.05-21.132-1.144a24 24 0 0 0-.616-1.319c8.586 1.279 17.238 1.956 25.94 1.033 10.74-1.143 21.327-4.444 30.02-11.009 8.451-6.385 14.324-15.413 19.535-24.487 5.091-8.857 9.636-18.056 15.75-26.277 1.815-2.437 3.776-4.835 5.913-7.067.276-.29.562-.577.843-.862 3.35-3.366 7.107-6.31 11.335-8.397.221.11.442.216.652.326z"
    ></path>
    <path
      fill="#fff"
      d="M158.343 64.44a170 170 0 0 1-8.01-.862 171 171 0 0 1-11.632-1.952c-.351-.075-.707-.145-1.058-.225a166 166 0 0 1-13.362-3.406 166.5 166.5 0 0 1-24.812-9.69c-7.88-3.832-15.594-8.261-22.656-13.462-4.53-3.33-9.284-7.534-11.807-12.735.346-.015.682-.02 1.018-.02C69.27 28.026 74.982 32.46 80.5 36.177a161 161 0 0 0 22.852 12.825c8 3.676 16.301 6.69 24.777 9.028q5.14 1.423 10.363 2.508.534.11 1.068.22c4.755.959 9.55 1.706 14.37 2.233 1.429.155 2.854.296 4.288.406.055.351.1.702.126 1.043M113.834 128.707c-.161.376-.326.747-.487 1.113a80 80 0 0 0-2.628.642c-3.983 1.028-7.895 2.337-11.636 4.043-3.336 1.519-6.526 3.345-9.465 5.542a43 43 0 0 0-7.624 7.273 37 37 0 0 0-2.984 4.248c-.11.176-.21.346-.316.527q-.414.031-.828.04c.346-.692.733-1.375 1.144-2.042a38 38 0 0 1 3.13-4.293c2.302-2.744 5.02-5.146 7.93-7.233 3.079-2.202 6.414-4.027 9.895-5.517 3.862-1.65 7.875-2.914 11.963-3.902a99 99 0 0 1 1.911-.441z"
    ></path>
    <path
      fill="url(#paint1_linear_1_10286)"
      fillOpacity="0.8"
      d="M104.555 35.16c-1.525-1.936-3.316-5.688-1.931-7.283 3.22-3.712 22.741 5.352 21.993 8.918-.586 2.803-14.415 5.537-20.062-1.635"
    ></path>
    <path
      fill="#fff"
      d="m90.2 40.798-42.18 7.361c-8.848 1.544-14.768 9.968-13.224 18.816l7.361 42.18c1.545 8.847 9.969 14.768 18.816 13.223l42.18-7.361c8.847-1.544 14.768-9.968 13.224-18.816l-7.362-42.18c-1.544-8.847-9.968-14.767-18.816-13.223"
    ></path>
    <path
      fill="#fff"
      d="m91.913 40.753-39.357 6.869c-8.254 1.44-13.778 9.3-12.337 17.555l6.869 39.356c1.44 8.255 9.3 13.778 17.554 12.338L104 110.002c8.254-1.441 13.778-9.3 12.337-17.555l-6.868-39.356c-1.441-8.255-9.3-13.779-17.555-12.338"
    ></path>
    <path
      fill="#D70431"
      d="M82.385 60.384c1.588-2.549 2.388-3.824 3.645-4.186.13-.035.259-.07.389-.093 1.293-.22 2.567.58 5.117 2.166 2.549 1.588 3.824 2.387 4.186 3.645.035.13.07.259.093.389.22 1.293-.579 2.567-2.166 5.117l-2.435 3.9c-1.718 2.752-2.582 4.135-2.26 5.524.324 1.39 1.7 2.248 4.459 3.972l3.9 2.434c2.537 1.588 3.817 2.381 4.18 3.639.035.13.07.259.087.395.22 1.293-.573 2.561-2.167 5.105-1.588 2.536-2.381 3.817-3.638 4.18-.13.035-.26.07-.396.087-1.293.22-2.561-.574-5.104-2.167l-3.9-2.435c-2.753-1.718-4.135-2.582-5.525-2.26-1.389.324-2.248 1.7-3.971 4.458l-2.435 3.9c-1.587 2.55-2.387 3.825-3.644 4.187-.13.035-.26.071-.39.093-1.292.221-2.567-.579-5.116-2.166-2.55-1.588-3.824-2.387-4.187-3.645a4 4 0 0 1-.093-.389c-.22-1.292.58-2.567 2.167-5.117l2.434-3.9c1.718-2.752 2.583-4.135 2.26-5.524s-1.7-2.248-4.458-3.972l-3.894-2.428c-2.543-1.594-3.818-2.381-4.18-3.639a3 3 0 0 1-.087-.395c-.22-1.293.573-2.561 2.167-5.104 1.588-2.537 2.381-3.818 3.638-4.18.13-.036.26-.07.396-.088 1.293-.22 2.561.574 5.104 2.167l3.894 2.429c2.752 1.718 4.135 2.583 5.524 2.26s2.248-1.7 3.972-4.458z"
    ></path>
    <path
      fill="url(#paint2_linear_1_10286)"
      fillOpacity="0.8"
      d="M46.788 61.561c-1.151-1.099-.07-4.07.888-5.678 2.013-3.367 5.67-4.308 6.654-4.527 3.112-.677 7.587-.229 8.079 1.512.782 2.75-8.86 7.208-9.406 7.454-2.382 1.08-5.09 2.32-6.215 1.24"
    ></path>
    <path
      fill="url(#paint3_linear_1_10286)"
      fillOpacity="0.8"
      d="M47.676 65.923c.404-1.283 1.784-2.065 3.015-2.04 2.092.036 4 2.418 3.375 4.264-.457 1.354-2.215 2.18-3.727 1.864-1.81-.378-3.208-2.374-2.663-4.079z"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.16"
      d="m91.913 40.753-39.357 6.869c-8.254 1.44-13.778 9.3-12.337 17.555l6.869 39.356c1.44 8.255 9.3 13.778 17.554 12.338L104 110.002c8.254-1.441 13.778-9.3 12.337-17.555l-6.868-39.356c-1.441-8.255-9.3-13.779-17.555-12.338"
    ></path>
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.16"
      d="m90.2 40.798-42.18 7.361c-8.848 1.544-14.768 9.968-13.224 18.816l7.361 42.18c1.545 8.847 9.969 14.768 18.816 13.223l42.18-7.361c8.847-1.544 14.768-9.968 13.224-18.816l-7.362-42.18c-1.544-8.847-9.968-14.767-18.816-13.223"
    ></path>
    <path
      fill="#D70431"
      fillOpacity="0.2"
      d="M84.022 62.396c1.587-2.55 2.387-3.825 3.645-4.187.13-.035.259-.07.388-.093 1.293-.22 2.568.58 5.117 2.167s3.825 2.387 4.187 3.644c.035.13.07.26.093.389.22 1.293-.58 2.568-2.166 5.117l-2.435 3.9c-1.718 2.752-2.583 4.135-2.26 5.524s1.7 2.248 4.458 3.972l3.9 2.435c2.537 1.587 3.818 2.38 4.181 3.638.035.13.07.259.087.395.22 1.293-.574 2.562-2.167 5.105-1.588 2.537-2.382 3.817-3.639 4.18a3 3 0 0 1-.395.087c-1.293.22-2.561-.573-5.105-2.167l-3.9-2.435c-2.752-1.717-4.135-2.582-5.524-2.26-1.389.324-2.248 1.7-3.972 4.459l-2.434 3.9c-1.588 2.549-2.387 3.824-3.645 4.187a4 4 0 0 1-.389.092c-1.292.221-2.567-.579-5.117-2.166s-3.824-2.387-4.186-3.644c-.035-.13-.07-.26-.093-.39-.22-1.292.58-2.567 2.166-5.116l2.435-3.9c1.718-2.753 2.583-4.135 2.26-5.525-.323-1.389-1.7-2.248-4.458-3.971l-3.894-2.429c-2.543-1.594-3.818-2.381-4.18-3.638a3 3 0 0 1-.087-.396c-.22-1.292.573-2.561 2.167-5.104 1.587-2.537 2.38-3.818 3.638-4.18.13-.036.26-.07.395-.087 1.293-.221 2.562.573 5.105 2.167l3.894 2.428c2.752 1.718 4.135 2.583 5.524 2.26s2.248-1.7 3.972-4.458z"
    ></path>
    <path
      fill="url(#paint4_linear_1_10286)"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.16"
      d="M82.385 60.384c1.588-2.549 2.388-3.824 3.645-4.186.13-.035.259-.07.389-.093 1.293-.22 2.567.58 5.117 2.166 2.549 1.588 3.824 2.387 4.186 3.645.035.13.07.259.093.389.22 1.293-.579 2.567-2.166 5.117l-2.435 3.9c-1.718 2.752-2.582 4.135-2.26 5.524.324 1.39 1.7 2.248 4.459 3.972l3.9 2.434c2.537 1.588 3.817 2.381 4.18 3.639.035.13.07.259.087.395.22 1.293-.573 2.561-2.167 5.105-1.588 2.536-2.381 3.817-3.638 4.18-.13.035-.26.07-.396.087-1.293.22-2.561-.574-5.104-2.167l-3.9-2.435c-2.753-1.718-4.135-2.582-5.525-2.26-1.389.324-2.248 1.7-3.971 4.458l-2.435 3.9c-1.587 2.55-2.387 3.825-3.644 4.187-.13.035-.26.071-.39.093-1.292.221-2.567-.579-5.116-2.166-2.55-1.588-3.824-2.387-4.187-3.645a4 4 0 0 1-.093-.389c-.22-1.292.58-2.567 2.167-5.117l2.434-3.9c1.718-2.752 2.583-4.135 2.26-5.524s-1.7-2.248-4.458-3.972l-3.894-2.428c-2.543-1.594-3.818-2.381-4.18-3.639a3 3 0 0 1-.087-.395c-.22-1.293.573-2.561 2.167-5.104 1.588-2.537 2.381-3.818 3.638-4.18.13-.036.26-.07.396-.088 1.293-.22 2.561.574 5.104 2.167l3.894 2.429c2.752 1.718 4.135 2.583 5.524 2.26s2.248-1.7 3.972-4.458z"
    ></path>
    <path
      fill="#fff"
      d="M77.143 73.348c.095-1.19 2.935-1.133 4.422-3.086.412-.542.893-1.462 1.505-2.63.294-.566.533-1.058 1.12-1.292.514-.206 1.238-.189 1.533.135.288.311.06.784-.402 1.85-1.205 2.78-.99 2.6-1.345 3.106-.49.7-1.174 1.68-2.53 2.34-1.197.585-3.18 1.05-3.974.32-.066-.062-.367-.34-.332-.738z"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_1_10286"
        x1="79.722"
        x2="79.722"
        y1="22.075"
        y2="152.167"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6169" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#FB1F23" stopOpacity="0.52"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_1_10286"
        x1="113.383"
        x2="113.383"
        y1="27.001"
        y2="39.729"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6169" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#FB1F23" stopOpacity="0.52"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_1_10286"
        x1="54.372"
        x2="54.372"
        y1="51.055"
        y2="61.978"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6169" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#FB1F23" stopOpacity="0.52"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_1_10286"
        x1="50.872"
        x2="50.872"
        y1="63.883"
        y2="70.078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF6169" stopOpacity="0.4"></stop>
        <stop offset="1" stopColor="#FB1F23" stopOpacity="0.52"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_1_10286"
        x1="95.457"
        x2="61.379"
        y1="61.139"
        y2="97.406"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F58AB8"></stop>
        <stop offset="1" stopColor="#F21C4A"></stop>
      </linearGradient>
    </defs>
  </svg>
);

export default ErrorSvg;
